import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Redirect } from 'react-router-dom';
import renderHTML from 'react-render-html';
import { Fade } from 'react-reveal';
import { Actions } from '../../../flux';
import { images, texts, relacionamentos } from '../../../settings';
import { DelayLink, SliderText } from '../../../components';

import '../Iniciativas.scss';
import './ProgramaDeSupervisaoDigital.scss';

class ProgramaDeSupervisaoDigital extends Component {
  constructor(props) {
		super(props);

		this.state = {
			selected: 'mulher',
			mobile: (window.innerWidth < 768) ? true : false
		}

		this.contentText = React.createRef();
  }

  scrollTop = () => {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  }

  componentDidMount = () => {
    Actions.headerIntern();
		this.scrollTop();

		// if (this.state.mobile == true) {
		// 	this.mobileNav();
		// }
	}
	
	mobileNav = () => {
	}

	changeItem = () => {
		const { selected } = this.state
		this.setState({
			selected: (selected == 'mulher') ? 'homem' : 'mulher'
		});
	}

  render = () => {
		const { selected } = this.state
    return (
      <div className="views" ref={this.contentText}>
				<Helmet>
					<title>Supervisão Digital - Iniciativas - {texts.title}</title>
				</Helmet>
				
				<div className="iniciativas-home treinamentos-home page-gradient page-gradient--yellow bg-gray bg-programa-de-supervisao" ref="treinamentos-home">
					<section className="iniciativas-area page--yellow">
						<div className="container container--large">
							<div className="row">
								<div className="col-12">
									<Fade bottom>
										<div className={`card card--page-body card--light-blue`}>
											<div className="card__content">
												<div className="card__content__header after-header-programa-de-supervisao">
													<DelayLink to={`/estrategias/dentro-de-casa`} className="button button--aylen button--gray-500 button--border-medium button--size-m button--round-l button--text-thick">
														Voltar
													</DelayLink>
													<h1 className="title title--gray titulo-programa-de-supervisao">
														<span className="gri_text gri_text--fixed">
															Supervisão Digital automatiza processos
														</span>
													</h1>
												</div>
												<div className="conteudo-programa-de-supervisao">
													<p>
														Avançamos na implantação de novas tecnologias para as atividades de monitoramento de mercado, com a utilização de inteligência artificial e machine learning. O Programa de Supervisão Digital automatizou mais de 30 processos com o uso de robôs, consolidando ganhos significativos de eficiência: o tempo de execução  caiu em até 93% em relação à prática anterior e foram economizadas cerca de 520 horas/mês dos nossos funcionários, que puderam se concentrar em atividades de maior valor agregado, especialmente análises qualitativas dos processos da supervisão.
														<br/><br/>
														O projeto de automatização da supervisão de mercados foi desenhado em 2019 e começou a ser executado em 2020. Para isso, contamos com o desenvolvimento de diversos sistemas com o apoio de terceiros. Saiba mais:
													</p>
												<img className="imagem-mobile" src={images.programa_de_supervisao_digital.img_hero} alt="Home"/> 
                        <div className="imagem-animada-supervisao">
                          <img src={images.programa_de_supervisao_digital.casa} alt="Casa"/>
                          <img className="imagem-celular" src={images.programa_de_supervisao_digital.celular} alt="celular"/>
                        </div>
												</div>

												<ul className="box-conteudo-programa-de-supervisao">
													<li>Implementado um sistema que automatiza a verificação do enquadramento dos fundos de investimento. É analisado se os ativos que compõem a carteira de um fundo estão de acordo com o estabelecido no regulamento. A ferramenta foi utilizada de maneira piloto em 2020 e será efetivamente operacionalizada em 2021.</li>
													<li>Iniciado o desenvolvimento de um projeto pioneiro para otimização do registro de ofertas públicas, com o uso de um formulário inteligente.</li>
													<li>Passamos a utilizar inteligência artificial nos processos de registro e alteração de fundos de investimentos. Com isso, entre os mais de 70 campos utilizados para o registro dos fundos, 40 passaram a ser processados automaticamente.</li>
												</ul>
											</div>
										</div>
									</Fade>
								</div>
							</div>
						</div>
					</section>
				</div>
      </div>
    );
  }
}

export { ProgramaDeSupervisaoDigital };
